import { buildSourceExternalKey, normalizeAccountingSourceId, normalizeAccountingSourceType } from "./sourceExternalKey";

export const BILL_TYPES = Object.freeze({
  ALL: "all",
  SUPPLIER: "supplier",
  DECORATOR: "decorator",
  SHIPPING_ACCOUNT: "shipping-account",
  OTHER_SERVICE: "other-service",
  INTERNAL_DECORATION: "internal-decoration",
});

const objectValue = (value) => {
  if (value && typeof value === "object") return value;
  if (typeof value !== "string") return {};
  try { return JSON.parse(value) || {}; } catch { return {}; }
};

export const otherServicePartyKey = (sourceType, sourceId) =>
  buildSourceExternalKey(sourceType, sourceId);

export const resolveBillParty = (rowOrBill = {}) => {
  const bill = rowOrBill?.bill && typeof rowOrBill.bill === "object" ? rowOrBill.bill : rowOrBill;
  const meta = objectValue(bill?.billSupplier);
  const poInfo = objectValue(bill?._poSupplierInfo || bill?.supplierInfo);
  const party = objectValue(poInfo?.party);
  const sourceType = normalizeAccountingSourceType(bill?.sourceType || meta?.sourceType || party?.sourceType || poInfo?.serviceSourceType || null);
  const sourceId = normalizeAccountingSourceId(bill?.sourceId || meta?.sourceId || party?.sourceId || poInfo?.serviceSourceId || null);
  const storedType = String(bill?.billPartyType || meta?.type || party?.partyType || "").toLowerCase();

  if (storedType === BILL_TYPES.OTHER_SERVICE || (sourceType && sourceId && poInfo?.isArtworkFulfillmentGroup)) {
    return {
      partyType: BILL_TYPES.OTHER_SERVICE,
      partyId: otherServicePartyKey(sourceType, sourceId),
      partyName: bill?.billPartyName || meta?.Name || party?.partyName || poInfo?.supplierName || "Other Service",
      sourceType,
      sourceId,
    };
  }
  if (bill?.isInternalDecoration === true) return { partyType: BILL_TYPES.INTERNAL_DECORATION };
  if (storedType === BILL_TYPES.SHIPPING_ACCOUNT) return { partyType: BILL_TYPES.SHIPPING_ACCOUNT };
  if (storedType === BILL_TYPES.DECORATOR || bill?.decoratorId != null) return { partyType: BILL_TYPES.DECORATOR };
  return { partyType: BILL_TYPES.SUPPLIER };
};

export const getOtherServiceProviders = (rows = []) => {
  const providers = new Map();
  rows.forEach((row) => {
    const party = resolveBillParty(row);
    if (party.partyType === BILL_TYPES.OTHER_SERVICE && party.partyId && !providers.has(party.partyId)) {
      providers.set(party.partyId, { id: party.partyId, name: party.partyName, sourceType: party.sourceType, sourceId: party.sourceId });
    }
  });
  return [...providers.values()].sort((a, b) => a.name.localeCompare(b.name) || a.id.localeCompare(b.id));
};

export const filterBillsByParty = (rows = [], billType = BILL_TYPES.ALL, providerId = "") =>
  rows.filter((row) => {
    const party = resolveBillParty(row);
    if (billType !== BILL_TYPES.ALL && party.partyType !== billType) return false;
    return billType !== BILL_TYPES.OTHER_SERVICE || !providerId || party.partyId === providerId;
  });
